import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "initialPrompt", "onChange", "onError", "onSubmit", "onWorkspaceCreated", "referrer", "value"];
import AIIconButton from 'ai-components-ui-library/components/buttons/AIIconButton';
import { AITextInput } from 'ai-components-ui-library/components/inputs/AITextInput';
import { NOT_USING_TRACKER } from 'ai-components-ui-library/hooks/useTracker';
import { SendIcon } from 'foundations-assets/icons/components/SendIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { useAppBuilderPromptSubmission } from './hooks/useAppBuilderPromptSubmission';
import { jsx as _jsx } from "react/jsx-runtime";
export function AppBuilderPromptInput(_ref) {
  let {
      disabled,
      initialPrompt,
      onChange,
      onError,
      onSubmit,
      onWorkspaceCreated,
      referrer,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    promptValue,
    isSubmitting,
    isSubmitDisabled,
    handleChange,
    handleKeyDown,
    handleSubmit
  } = useAppBuilderPromptSubmission({
    disabled,
    initialPrompt,
    onChange,
    onError,
    onSubmit,
    onWorkspaceCreated,
    referrer,
    value
  });
  return /*#__PURE__*/_jsx(AITextInput, Object.assign({
    disabled: !!disabled,
    loading: isSubmitting,
    paddingInlineEnd: "1000",
    placeholder: unescapedText('app.promptInput.placeholder'),
    value: promptValue,
    onChange: e => handleChange(e.target.value),
    onKeyDown: handleKeyDown,
    triggerButton: /*#__PURE__*/_jsx(AIIconButton, {
      "aria-label": unescapedText('app.promptInput.buildButton'),
      disabled: isSubmitDisabled,
      onClick: handleSubmit,
      shape: "circle",
      size: "xs",
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.promptInput.buildButton"
      }),
      type: "button",
      usageTracker: NOT_USING_TRACKER,
      children: /*#__PURE__*/_jsx(SendIcon, {})
    })
  }, rest));
}